/**
 * 关于user信息存储的一些工具方法，主要是一些cookies storage
 */
import { COOKIE_KEY_TOKEN as TOKEN_KEY } from '@/config/constant';
import Cookies from '@/utils/cookies';
/**
 * 设置token
 */
export function setToken(token, options = {}) {
	Cookies.set(TOKEN_KEY, token, options);
}

/**
 * 获取token
 */
export function getToken() {
	return Cookies.get(TOKEN_KEY);
}

/**
 * 删除token
 */
export function removeToken() {
	Cookies.remove(TOKEN_KEY);
}
/**
 * 是否存在token
 */
export function hasToken() {
	return Cookies.has(TOKEN_KEY);
}

/**
 * 删除指定的localStorage
 * @params { array } expect 传入的数组是希望删除的 不传值 默认删除全部localStorage
 */
export function removeLocalStorages(expect) {
	expect = expect || [];
	if (expect.length) {
		expect.forEach(item => {
			localStorage.removeItem(item);
		});
	} else {
		localStorage.clear();
	}
}
